import React, { useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaRupeeSign,
} from "react-icons/fa";
import "./LocationDetails.css";
import { Link, useParams } from "react-router-dom";
import Header from "../Header";
import host from "../../config";
const RaoGopalRaoAuditorium = () => {
  const { id } = useParams();
  const [ImagesList, setImagesList] = useState([]);
  console.log(useParams());
  useEffect(() => {
    if (!id) return; // Prevent running if ID is not available

    fetch(`${host}/get-booking-images-by-id`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }), // Correct JSON structure
    })
      .then((response) => response.json())
      .then((res) => {
        setImagesList(res);
        console.log("Fetched Images:", res);
      })
      .catch((error) => console.error("Error fetching images:", error));
  }, [id]); // Only depends on id

  // const images = [
  //   "/images/submarine 1.png",
  //   "/images/submarine 2.png",
  //   "/images/submarine 2.png",
  // ];

  const pricingData = [
    {
      id: 1,
      purpose:
        "Birthday functions and other Official / Corporate meetings / Get-together functions (General Public)",
      rent: 25000,
      deposit: 20000,
      gst: 5400,
      cleaning: 5000,
      total: 55400,
    },
  ];

  return (
    <div>
      <Header />
      <div className="location-page">
        {/* Hero Section */}
        <div className="hero">
          <Carousel showThumbs={false} autoPlay interval={3000} infiniteLoop>
            {ImagesList.map((item, idx) => (
              <div key={idx} className="carousel-image">
                <img
                  src={item.url}
                  alt={`Rao Gopal Rao Auditorium Image ${idx + 1}`}
                />
                <div className="overlay">
                  <h1>Rao Gopal Rao Auditorium, Anakapalli</h1>
                  <p>Perfect Venue for Social and Corporate Events</p>
                </div>
              </div>
            ))}
          </Carousel>
        </div>

        {/* Venue Details */}
        <div className="location-details">
          <h2>About the Venue</h2>
          <p className="line-height">
            <strong>Rao Gopal Rao Auditorium</strong>, located in{" "}
            <strong>Anakapalli</strong>, is a versatile venue ideal for birthday
            functions, corporate meetings, and get-together events. The
            auditorium offers modern amenities and ample space to accommodate
            guests comfortably.
          </p>

          {/* Pricing Section */}
          <h3>📌 Venue Pricing Details</h3>
          <div className="pricing-container">
            {pricingData.map((item) => (
              <div key={item.id} className="pricing-card">
                <h4>{item.purpose}</h4>
                <p>
                  <FaRupeeSign /> Rent per Day:{" "}
                  <strong>{item.rent.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Security Deposit:{" "}
                  <strong>{item.deposit.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> GST (18%):{" "}
                  <strong>{item.gst.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Cleaning Charges:{" "}
                  <strong>{item.cleaning.toLocaleString()}</strong>
                </p>
                <p className="total">
                  <FaRupeeSign />{" "}
                  <strong>Total: {item.total.toLocaleString()}</strong>
                </p>
              </div>
            ))}
          </div>

          {/* Contact Section */}
          <h3>📞 Contact Information</h3>
          <div className="contact-info">
            <p>
              <FaMapMarkerAlt /> Location: Anakapalli, Visakhapatnam
            </p>
            <p>
              <FaPhoneAlt /> Phone: +91 98765 43210
            </p>
            <p>
              <FaEnvelope /> Email: info@raogopalraoauditorium.com
            </p>
          </div>

          {/* Book Now Button */}
          <Link to="/" className="book-now-btn">
            Book Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RaoGopalRaoAuditorium;
